import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { classNumberLabel } from "../util/classDisplay";

// #864 — canonical class identity, mirroring RideLink (#860): the shared
// place every class-display site routes through so a class reads the same
// way everywhere and — outside pickers/autocompletes, where a link makes no
// sense (App.jsx's `/classes/:classId` opens ClassManager's detail drawer,
// #863) — is always clickable straight into it. Degrades gracefully: no
// `classObj`/`children` falls back to `fallback`; no resolvable id renders
// as plain (unlinked) text instead of a dead link.
//
// Most sites want the default label (`classNumberLabel()`, "12. Training
// Level Test 1"). ClassManager's own table keeps its class-number and
// class-name in two separate, non-duplicating columns (#673) — `children`
// lets a caller supply its own label text while still getting the shared
// link/style, rather than forking a second component for that one layout.
export default function ClassLink({ classObj, classId, children, fallback = "—", sx, ...linkProps }) {
  const id = classId ?? classObj?.id ?? classObj?.classId ?? null;
  const label = children ?? (classObj ? classNumberLabel(classObj) : null) ?? fallback;

  if (!id) return label;

  return (
    <Link component={RouterLink} to={`/classes/${id}`} color="text.primary" underline="always" sx={sx} {...linkProps}>
      {label}
    </Link>
  );
}
